import React from 'react'
import {
  FormControl,
  FormHelperText,
  FormLabel,
  CircularProgress,
  TextField,
  Avatar
} from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { useStyles } from './style'
import { ChevronDown, X } from 'lucide-react'
import { generateColor } from '../../helpers/colorGenerator'
import { getInitials } from '../../helpers/getInitials'

export default function AutocompleteInput({
  error,
  helperText,
  label,
  id,
  options = [],
  loading = false,
  value,
  onChange,
  getOptionLabel,
  placeholder,
  size = 'medium',
  ...rest
}) {
  const classes = useStyles()

  return (
    <FormControl
      error={error}
      fullWidth
      className={`${classes.formControl} ${size === 'small' ? 'small' : ''}`}
    >
      {label && (
        <FormLabel
          id={`${id || label}-label`}
          htmlFor={id || label}
          className={classes.label}
        >
          {label}
        </FormLabel>
      )}

      <Autocomplete
        {...rest}
        id={id || label}
        options={options}
        loading={loading}
        value={value}
        onChange={onChange}
        getOptionLabel={getOptionLabel}
        popupIcon={<ChevronDown className={classes.iconChevronDown} />}
        closeIcon={
          <X
            size={18}
            className={classes.iconChevronDown} // Ou use uma classe específica para o botão de fechar
          />
        }
        classes={{
          listbox: classes.menuList
        }}
        
        renderOption={option => (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              width: '100%'
            }}
            aria-label={`${option.name}, telefone ${option.number}`}
          >
            <Avatar
              style={{
                backgroundColor: generateColor(option.number),
                width: size === 'small' ? 32 : 40,
                height: size === 'small' ? 32 : 40,
                fontSize: size === 'small' ? '0.85rem' : '1rem'
              }}
            >
              {getInitials(option.name)}
            </Avatar>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span className={classes.contactName}>
                {option.name}
              </span>
              <span className={classes.contactNumber}>
                {option.number}
              </span>
            </div>
          </div>
        )}
        renderInput={params => (
          <TextField
            {...params}
            variant="outlined"
            placeholder={placeholder}
            error={error}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              )
            }}
          />
        )}
      />
      {error && helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  )
}
